import { client } from "@/client";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";
import { useMutation } from "@apollo/client/react";
import {
  RemoveUserMutation,
  RemoveUserMutationVariables,
  RemoveUserDocument,
} from "@/graphql/__generated__/graphql";

/**
 * Custom hook for removing a user and handling the necessary cache updates.
 * @returns {Object} Contains the removeUserMutation function, loading state, and error state.
 */
export default function useRemoveUserMutationHook(): {
  removeUserMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [removeUserMutation, { loading, error }] = useMutation<RemoveUserMutation, RemoveUserMutationVariables>(
    RemoveUserDocument, {
      onCompleted: (data) => {
        toast(CustomToastComponent, {
          toastId: "user-removed-success",
          data: {
            title: t("toasts.userremoved"),
            content: t("toasts.userremovedsuccessfully"),
            type: "success",
          },
        });

        // Remove Service from cache
        client.cache.evict({
          id: `User:${data.removeUser}`,
        });
      },
    });

  return {
    removeUserMutation,
    loading,
    error,
  };
}
